import { containsComposed, getDeepActiveElement, isDocument } from "@videojs/utils/dom";
//#region src/dom/ui/slider/focus.ts
function isSliderFocused(root = document) {
	const doc = isDocument(root) ? root : root.ownerDocument;
	const active = getDeepActiveElement(doc);
	if (active?.getAttribute("role") !== "slider") return false;
	return isDocument(root) || containsComposed(root, active);
}
//#endregion
export { isSliderFocused };

//# sourceMappingURL=focus.js.map